function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMag = function SvgLogoMag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 104 90"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.125c-2.551-2.401-6.084-3.777-9.693-3.777-2.529 0-5 .668-7.156 1.932l-.003-.002-.002.002a14.35 14.35 0 0 0-7.202-1.932c-1.176 0-2.359.15-3.518.445l-.002-.002-.004.001c-2.42-1.966-5.339-2.809-9.729-2.809h-10.175V6.142H4.009V-4.056c0-4.901-1.311-8.522-4.009-11.069m-17.334-1.55q-.07.046-.14.094a16 16 0 0 0-.553.386q-.103.074-.202.15-.176.135-.345.275-.084.067-.166.135-.248.21-.483.429-.2.19-.389.386l-.107.111q-.144.151-.282.306l-.092.102q-.176.201-.341.407l-.046.059q-.141.18-.276.364l-.085.119q-.125.176-.243.356l-.055.083q-.143.221-.273.449l-.052.092q-.107.186-.204.377l-.065.126a13 13 0 0 0-.228.478 12 12 0 0 0-.4 1.025l-.045.131a14 14 0 0 0-.28.964q-.013-.114-.03-.227l-.03-.228a16 16 0 0 0-.07-.428q-.015-.092-.032-.184-.057-.304-.127-.606l-.013-.055a17 17 0 0 0-.14-.542q-.028-.097-.057-.194a14 14 0 0 0-.562-1.572q-.04-.098-.083-.196a13 13 0 0 0-.201-.432q-.028-.06-.057-.121a15 15 0 0 0-.281-.539l-.077-.133q-.111-.198-.228-.392l-.115-.183q-.105-.165-.214-.329l-.13-.19a14 14 0 0 0-.615-.812q-.06-.076-.123-.15a13 13 0 0 0-.397-.45 13 13 0 0 0-.371-.38l-.103-.1q-.154-.15-.311-.292l-.058-.055a13.82 13.82 0 0 1 9.777 1.386m-9.838 18.914q-.078.07-.157.141-.164.152-.332.297-.1.082-.202.16-.153.127-.312.248-.113.081-.228.161c-.103.072-.205.147-.311.216q-.123.08-.248.154-.156.099-.315.193-.133.073-.267.144-.16.089-.323.173-.14.067-.282.132-.165.08-.333.154-.147.061-.298.12-.17.07-.343.136-.156.056-.314.108-.175.061-.354.118-.163.049-.328.094-.18.053-.367.102-.169.042-.341.081-.188.045-.38.086-.176.034-.356.066-.194.037-.393.07-.183.029-.369.053-.202.03-.407.054-.19.021-.383.039-.209.021-.422.039-.196.014-.396.024-.216.014-.436.023-.203.008-.409.011-.162.005-.325.006v-9.739c0-5.04 1.117-8.154 3.853-10.747q.145-.136.294-.267.049-.043.099-.084a9 9 0 0 1 .204-.174l.124-.1q.093-.075.187-.148.07-.055.142-.107.088-.067.177-.132.075-.054.152-.107.087-.062.176-.123l.157-.103q.09-.06.179-.117l.164-.1.179-.11.169-.096q.091-.053.182-.103.086-.047.173-.092.091-.05.185-.098.087-.044.176-.087l.188-.092.181-.083q.094-.044.189-.085.091-.04.184-.078l.193-.08.186-.072a7 7 0 0 1 .384-.141q.1-.036.202-.07l.188-.061.205-.064q.094-.028.19-.054l.145-.041.119.102q.059.05.116.102a13 13 0 0 1 .284.261q.095.09.189.184l.089.088q.138.138.272.281c2.25 2.422 3.54 5.794 3.54 9.25q0 .287-.013.587-.004.094-.012.189-.01.212-.027.427l-.012.142v.007c-.291 3.045-1.554 5.908-3.557 8.062q-.227.242-.464.47m-10.423-6.336v9.743h-9.397v-26.417h9.683c4.099 0 6.868.744 9.141 2.476l-.234.074-.138.044q-.197.065-.39.135-.04.014-.079.03-.155.056-.308.117l-.145.059q-.12.049-.237.099l-.159.07-.218.098-.162.078q-.105.05-.208.102-.082.041-.163.084l-.201.106-.162.089-.195.111a8 8 0 0 0-.351.21l-.156.098-.188.123-.151.101-.187.13-.145.104-.186.139-.137.104-.19.151q-.063.05-.125.102a9 9 0 0 0-.204.174q-.052.043-.102.087-.151.133-.298.27c-2.847 2.699-4.008 5.917-4.008 11.109m14.363 9.743h-9.429l.182-.046q.077-.019.154-.039.324-.082.638-.178l.07-.023q.286-.09.563-.19l.137-.049q.298-.11.586-.233l.098-.044q.255-.112.501-.232l.113-.056q.275-.138.539-.289l.108-.063q.234-.137.461-.283l.085-.055q.252-.166.494-.345l.108-.083q.223-.168.438-.348l.049-.039a12 12 0 0 0 .555-.505q.222-.212.434-.438.173-.187.338-.381l.087-.102a12 12 0 0 0 .286-.35l.04-.049q.154-.2.303-.406l.075-.106q.123-.174.242-.354l.053-.079a14 14 0 0 0 .54-.904l.053-.096q.122-.227.236-.459l.038-.078q.097-.202.19-.407l.046-.104q.105-.241.203-.486l.014-.038q.09-.228.171-.461l.037-.105q.086-.249.164-.502zm12.386 0h-11.893v-9.743a29 29 0 0 1 .078-2.155l.002-.017.006-.074.004-.054V-6.4q.015-.154.031-.305.018-.195.039-.385.019-.158.041-.311.022-.174.047-.344.027-.17.057-.337.024-.148.05-.293.037-.181.077-.36.025-.123.052-.246.047-.192.098-.38.026-.103.052-.203.058-.2.121-.394.025-.084.051-.168.072-.21.148-.413l.046-.129q.084-.21.173-.414.022-.054.045-.109.094-.208.196-.411.022-.047.045-.094.105-.206.22-.407.022-.041.045-.082.114-.195.235-.385l.055-.089q.122-.186.251-.367l.064-.093q.125-.17.257-.337.042-.056.084-.11.127-.157.262-.311.053-.062.105-.125.117-.13.24-.258.076-.084.155-.168.203-.21.421-.416.236-.22.485-.431.082-.068.166-.134.17-.14.347-.275.105-.078.213-.155.161-.118.325-.231.12-.08.241-.157.128-.083.258-.164.144.089.284.179.123.078.245.158.176.12.347.246.112.079.223.16.184.14.361.287.091.07.18.144.263.22.511.454c2.593 2.449 3.854 5.951 3.854 10.707zm14.363 0h-13.871v-9.702c0-4.9-1.311-8.521-4.009-11.069a14 14 0 0 0-.51-.453q-.085-.071-.173-.141-.18-.148-.366-.29-.106-.08-.214-.158a15 15 0 0 0-.587-.406q-.077-.053-.156-.104a13.7 13.7 0 0 1 6.676-1.73c3.486 0 6.896 1.328 9.356 3.644 2.593 2.448 3.854 5.95 3.854 10.707z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(95.415 42.736)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52 334.219h51.499v.501H42.52z",
    style: {
      fill: "#1a1a1a"
    },
    transform: "translate(-85.439 -582.913)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817V1.018c-.029.197-.034.22-.144.544l-.868 2.255h-.649l-.793-2.215c-.069-.225-.087-.283-.144-.607v2.822h-.655V0h.868l1.011 2.724c.046.11.058.15.075.295.023-.179.029-.202.069-.295L-.178 0H.69v3.817z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(24.302 62.371)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.336c-.276.191-.598.278-1.069.278-.477 0-.788-.081-1.075-.278-.391-.272-.517-.59-.517-1.29V-.278h.718v2.365c0 .567.293.85.897.85.552 0 .845-.301.845-.85V-.278h.724v2.324c0 .7-.126 1.013-.523 1.29",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(33.266 62.93)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.012q-.603-.27-.983-.272c-.339 0-.557.139-.557.353 0 .162.092.26.362.405q.87.467 1.138.734a.98.98 0 0 1 .258.683C.218.573-.276.972-1.115.972c-.115 0-.23-.012-.339-.023-.27-.041-.397-.081-.793-.266-.052-.023-.138-.064-.248-.116l.305-.671c.276.151.391.208.54.266.19.07.397.11.546.11.334 0 .552-.15.552-.381 0-.162-.086-.272-.333-.411l-.586-.336c-.673-.387-.88-.641-.88-1.058 0-.191.058-.387.15-.532.063-.098.161-.196.281-.283.276-.191.512-.255.954-.255.253 0 .477.029.713.099.184.058.287.098.54.219z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(40.716 68.24)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817V0h2.311v.619H.724v.943h1.299v.618H.724v1.018h1.661v.619z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(42.986 62.371)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.336c-.276.191-.598.278-1.069.278-.477 0-.788-.081-1.075-.278-.391-.272-.517-.59-.517-1.29V-.278h.718v2.365c0 .567.293.85.897.85.552 0 .845-.301.845-.85V-.278h.724v2.324c0 .7-.127 1.013-.523 1.29",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(54.655 62.93)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817V1.018c-.029.197-.035.22-.144.544l-.868 2.255h-.649l-.793-2.215a4 4 0 0 1-.144-.607v2.822h-.655V0h.868l1.011 2.724c.046.11.058.15.075.295.023-.179.029-.202.069-.295L-.178 0H.69v3.817z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(64.49 62.371)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.507-.196-.619h-.835l-.204.619h-.498L-.831 0h.427l.902 2.507zM-.615.573l-.287.908h.577z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(73.98 63.38)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.53-1.069.908l-.053-.099q-.025-.046-.03-.053a.4.4 0 0 1-.034-.088v1.839h-.453V0h.548l1.045 1.649c.004.007.016.026.027.053l.023.049.022.065.023.045V0h.449v2.53z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(79.207 63.38)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.771c-.23.247-.559.368-1.008.368h-.921V-.368h.925c.472 0 .766.106 1.011.369.216.231.337.55.337.877 0 .335-.125.657-.344.893M-.457.202C-.589.103-.782.054-1.054.054h-.377v1.664h.377c.567 0 .884-.3.884-.836 0-.285-.109-.547-.287-.68",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(85.649 64.119)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.817-.299-.943h-1.27l-.311.943h-.758L-1.264 0h.649L.759 3.817zM-.937.874l-.437 1.382h.88z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(21.162 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817-.868 2.29h-.362v1.527h-.724V0H-.69C-.138 0 .115.07.339.283q.31.288.31.828 0 .44-.206.717c-.144.185-.276.266-.592.352l.942 1.637zM-.759.619h-.471v1.052h.471c.46 0 .661-.161.661-.543 0-.364-.189-.509-.661-.509",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(27.97 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.579V.619h-.724v-3.198h-1.138v-.619h3v.619z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(33.885 80.685)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.701a3.6 3.6 0 0 1-.954.127c-1.259 0-2.133-.809-2.133-1.989 0-.578.219-1.081.627-1.457.391-.359.828-.509 1.483-.509.276 0 .552.029.793.087C0 .006.115.046.379.162L.207.769a8 8 0 0 0-.311-.11A2.5 2.5 0 0 0-.885.52c-.851 0-1.443.527-1.443 1.284 0 .781.65 1.377 1.495 1.377.172 0 .27-.018.494-.081V2.047h.724v1.562c-.172.04-.299.075-.385.092",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(46.31 74.387)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.817-.299-.943h-1.27l-.31.943h-.759L-1.264 0h.649L.759 3.817zM-.937.874l-.437 1.382h.88z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(53.554 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817V0h.724v3.198h1.552v.619z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(56.443 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817V0h.724v3.198h1.552v.619z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(62.472 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817V0h2.31v.619H.724v.943h1.299v.618H.724v1.018h1.661v.619z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(68.478 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.817-.868 2.29h-.362v1.527h-.724V0H-.69C-.138 0 .115.07.339.283q.31.288.31.828 0 .44-.206.717c-.144.185-.277.266-.592.352l.942 1.637zM-.759.619h-.471v1.052h.471c.46 0 .661-.161.661-.543 0-.364-.189-.509-.661-.509",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(78.932 74.26)scale(2.00948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .543V2.18h-.724V.543l-1.156-2.18h.793l.759 1.492.799-1.492h.793z",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero"
    },
    transform: "translate(84.8 77.55)scale(2.00948)"
  }));
};
export { SvgLogoMag as ReactComponent };
export default __webpack_public_path__ + "static/logo-mag.0a323875.svg";